import { useGlobalSearch } from '@/components/provider/global-search-provider'
import { Button } from '@/components/ui/button'
import { SearchIcon } from 'lucide-react'
import { CustomKbd } from './custom-kbd'

export function SearchBar() {
  const { onOpenSearch } = useGlobalSearch()

  return (
    <Button
      variant="outline"
      className="min-w-48 justify-between"
      onClick={() => onOpenSearch()}
    >
      <div className="flex items-center gap-1">
        <SearchIcon />
        <span>Search...</span>
      </div>
      <CustomKbd
        suppressHydrationWarning
        ctrl
        keys={['K']}
      />
    </Button>
  )
}
